import { cn } from '../../../shared/lib/cn';
import { CheckIcon, CloseIcon } from '../../../shared/ui/icons';

interface ICheckResultProps {
  ok: boolean;
  /** "Works" / "535 · login refused": the first line. */
  title?: string;
  detail: string;
  className?: string;
}

// What the app answered, board 13: a mark and a word, then its own sentence in mono.
export const CheckResult = ({ ok, title, detail, className }: ICheckResultProps) => (
  <div
    role="status"
    className={cn(
      'rounded-control px-input py-3',
      ok ? 'bg-surface-sunken' : 'bg-danger-surface',
      className,
    )}
  >
    <p className={cn('flex items-center gap-2 text-data', ok ? 'text-primary' : 'text-danger')}>
      <span
        aria-hidden
        className={cn(
          'flex size-check shrink-0 items-center justify-center rounded-full text-surface',
          ok ? 'bg-success' : 'bg-danger',
        )}
      >
        {ok ? <CheckIcon size={10} /> : <CloseIcon size={10} />}
      </span>
      {title ?? (ok ? 'Works' : 'The check failed')}
    </p>
    <p className="mt-label font-mono text-meta leading-18 break-words text-muted">{detail}</p>
  </div>
);
